import {observable} from 'mobx';
import {ViewBase,Action} from 'mutants-appfx';

class ButtonModel extends ViewBase{
  get type(){
    return 'ButtonModel';
  }

    @observable label;
    @observable action;
    @observable funName;

    constructor(store,label,onClick,funName){
      super(store);
      this.label=label;
      this.onClick=onClick;
      this.funName=funName;
    }
    static fromJS(store, obj) {
      return new ButtonModel(store, obj.text,Action.fromJS(store,obj.onClick),obj.key);
    }
}
export default ButtonModel;
